import { render, staticRenderFns } from "./LiveExternalLinkTable.vue?vue&type=template&id=83978c74"
import script from "./LiveExternalLinkTable.vue?vue&type=script&lang=js"
export * from "./LiveExternalLinkTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports